import React, { useMemo } from 'react'
import Accordion from '_/views/finance/components/Accordion'
import {
  Grid,
  TextField,
  RadioGroup,
  Radio,
  FormControlLabel,
  InputLabel,
  FormHelperText,
} from '@mui/material'
import { useSelector } from 'react-redux'
import { currentServiceOrderSelector } from '_modules/service-orders/selectors'
import { Controller, useFormContext } from 'react-hook-form'

import { useBudgetForm } from '_/views/budget-view-v2/hooks/use-budget-form'
import { NumericInput } from '../../Inputs/NumericInput'

import useStyles from './styles'
import { useLocation } from '@reach/router'

export function FinalInformationAccordion() {
  const styles = useStyles()
  const { pathname } = useLocation()
  const serviceOrder = useSelector(currentServiceOrderSelector)
  const { isEditing, budget } = useBudgetForm()

  const isCreating = pathname.includes('/novo')
  const areButtonsDisabled = useMemo(() => !isEditing && !isCreating, [isEditing, isCreating])

  const {
    formState: { errors },
    control,
  } = useFormContext()

  const showConfidentialInfoField = useMemo(() => {
    const contractType = serviceOrder?.agency?.toJS()?.contractType

    return contractType?.toLowerCase() !== 'saas'
  }, [serviceOrder])

  const hasExtendedWarranty = useMemo(() => budget?.extendedWarranty ?? false, [budget])

  return (
    <Accordion id="final-informations" title="Outras informações">
      <Grid className={styles.wrapper}>
        <Grid>
          <InputLabel
            variant="body2"
            id="visitHappenedTemp-label"
            style={{ color: errors?.visitHappenedTemp?.message ? '#C90000' : null }}
            className={styles.label}
          >
            Houve visita presencial<span className={styles.required}>*</span>
          </InputLabel>
          <Controller
            name="visitHappenedTemp"
            control={control}
            render={({ value, onChange }) => {
              return (
                <RadioGroup
                  classes={{ root: styles.radioGroupStyles }}
                  onChange={e => onChange(e.target.value === 'true')}
                  value={value}
                  row
                >
                  <FormControlLabel
                    value="true"
                    control={<Radio disabled={areButtonsDisabled} />}
                    label="Sim"
                    classes={{ root: styles.labelInputRadioButton }}
                  />
                  <FormControlLabel
                    value="false"
                    control={<Radio disabled={areButtonsDisabled} />}
                    label="Não"
                    classes={{ root: styles.labelInputRadioButton }}
                  />
                </RadioGroup>
              )
            }}
          />
          <FormHelperText className={styles.errorMessage} error={!!errors?.visitHappenedTemp}>
            {errors?.visitHappenedTemp?.message}
          </FormHelperText>
        </Grid>
        <Grid>
          <InputLabel
            variant="body2"
            id="executionDue"
            style={{ color: errors?.executionDue?.message ? '#C90000' : null }}
            className={styles.label}
          >
            Prazo de execução (em dias)
          </InputLabel>
          <NumericInput
            name="executionDue"
            decimalScale={0}
            placeholder="0"
            disabled={areButtonsDisabled}
            labelClassName={styles.label}
            hasError={errors?.executionDue?.message}
          />
        </Grid>

        <Grid className={styles.teaxtArea}>
          <InputLabel variant="body2" id="additionalInfo-label" className={styles.label}>
            Deseja adicionar alguma informação?
          </InputLabel>
          <Controller
            name="additionalInfo"
            control={control}
            render={({ value, name, onChange }) => {
              return (
                <TextField
                  name={name}
                  value={value}
                  fullWidth
                  multiline
                  variant="outlined"
                  maxRows={10}
                  minRows={3}
                  className={styles.input}
                  onChange={onChange}
                  disabled={areButtonsDisabled}
                />
              )
            }}
          />
        </Grid>
        {showConfidentialInfoField && (
          <Grid>
            <InputLabel variant="body2" id="confidentialInfo-label" className={styles.label}>
              Deseja adicionar alguma informação específica para a Refera?
            </InputLabel>
            <Controller
              name="confidentialInfo"
              control={control}
              render={({ value, name, onChange }) => {
                return (
                  <TextField
                    name={name}
                    value={value}
                    fullWidth
                    multiline
                    variant="outlined"
                    maxRows={10}
                    minRows={3}
                    className={styles.input}
                    onChange={onChange}
                    disabled={areButtonsDisabled}
                  />
                )
              }}
            />
          </Grid>
        )}
        {hasExtendedWarranty && (
          <Grid style={{ width: '380px' }}>
            <InputLabel
              variant="body2"
              id="additionalWarrantyMonths-label"
              style={{ color: errors?.additionalWarrantyMonths?.message ? '#C90000' : null }}
              className={styles.label}
            >
              Quantos meses de garantia estendida?<span className={styles.required}>*</span>
            </InputLabel>
            <NumericInput
              name="additionalWarrantyMonths"
              decimalScale={0}
              placeholder="0"
              disabled={areButtonsDisabled}
              labelClassName={styles.label}
              hasError={errors?.additionalWarrantyMonths?.message}
            />
          </Grid>
        )}
      </Grid>
    </Accordion>
  )
}
